
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchAttribute'
})
export class SearchAttributePipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      return it.att_name.toLowerCase().includes(searchText);
    });
  }

}